<div style="display: flex; flex-direction: column; flex: 1; max-height: 100%;">
  <div class="header-color" style="display: flex; flex-direction: row;">
    <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;" translate>
      Assignments
    </div>
    <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; padding-right: 5px; justify-content: center">
      <button mat-stroked-button class="mat-card-button" (click)="viewAllClick()"><span translate>Go To Assignments</span></button>
    </div>
  </div>
  <div style="display: flex; flex-direction: column; flex: 1;overflow-y: auto">
    <table *ngIf="assignments.length > 0" mat-table [dataSource]="assignments" style="width: 100%; padding-bottom: 5px;">
      <!-- Due Column -->
      <ng-container matColumnDef="Due">
        <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black;" translate> Due </th>
        <td mat-cell *matCellDef="let assignment" [ngClass]="checkIfMissing(assignment)" style="font-size: 10pt;"> {{assignment.Due}} </td>
      </ng-container>

      <!-- Class Column -->
      <ng-container matColumnDef="Class">
        <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black" translate> Class </th>
        <td mat-cell *matCellDef="let assignment" style="font-size: 10pt; padding-right: 10px"> {{assignment.Class}} </td>
      </ng-container>

      <!-- Assignment Column -->
      <ng-container matColumnDef="Assignment">
        <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black" translate> Assignment </th>
        <td mat-cell *matCellDef="let assignment" style="font-size: 10pt; padding-right: 10px"> {{assignment.AssignmentName}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <div *ngIf="assignments.length == 0" style="display: flex; flex-direction: row; align-items: center; flex: 1; padding: 15px">
      <div style="display: flex; flex-direction: column; align-items: center;flex: 1;">
        <div style="display: flex; flex-direction: column" translate>
          No missing assignments in the last 30 days.
        </div>
        <div style="display: flex; flex-direction: column" translate>
          No assignments due today or tomorrow.
        </div>
      </div>
    </div>
  </div>
  <div style="display: flex; flex-direction: row; padding: 5px">
    <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; margin-left: 10px">
      <button mat-stroked-button class="mat-card-close-button" (click)="closeClick()">
          <span translate>Close</span>
      </button>
    </div>
  </div>
</div>
